// Wire Hey API's generated DMS client to our shared axios instance
// (auth interceptor, rate limiting, RFC 9457 Problem parsing)
import { apiClient } from '@/api/axios-client';
import { env } from '@/lib/env';
import { client } from './generated/client.gen';

client.setConfig({
  axios: apiClient,
  baseURL: env.VITE_API_BASE_URL,
});
